export var paramShouldInheritDesktop = function (param) {
    if (typeof param.inheritDesktop === 'undefined') {
        return true;
    }
    return param.inheritDesktop;
};
//# sourceMappingURL=paramShouldInheritDesktop.js.map